import type { AccountStatus } from '@/account/AccountService';

/**
 * gate.ts — the app-shell Racer ID boot gate rule (M111), PURE + unit-tested.
 *
 * Owner-locked (2026): the APPS require a Racer ID — guests are web-only.
 * The gate fronts the RACER ID screen (non-dismissable) the moment the
 * account layer RESOLVES signed-out inside the native shell:
 *  - never on the web (guests untouched);
 *  - never while status is 'loading' (the supabase chunk defers ~400 ms —
 *    the title may show for a beat first, exactly like a slow web boot);
 *  - never when 'disabled' (the SUPABASE_ENABLED kill switch must keep its
 *    full pre-M100 rollback power — no account layer means no gate);
 *  - signed-in players never see it, INCLUDING offline launches (the session
 *    restores from native storage without a network).
 */
export function shouldFrontAccountGate(
  native: boolean,
  accountEnabled: boolean,
  status: AccountStatus,
): boolean {
  return native && accountEnabled && status === 'signedOut';
}
